import React from 'react';
import {CompanyRuleDto} from "../../model/company/CompanyRuleDto";
import {selectedCompanyStore} from "../../store/SelectedCompany";
import {companyApi} from "../../backend/CompanyApi";
import {companyAccountsStore} from "../../store/CompanyAccounts";
import LoaderWithCompanySelected from "../../components/LoaderWithCompanySelected";
import {TxType} from "../../model/MatchedDocument";
import {creditTableRowStyle, debitTableRowStyle} from "../theme";
import RuleUpdateDialog from "./RuleUpdateDialog";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import {Button} from "@mui/material";
import ButtonWithConfirmation from "../../components/button/ButtonWithConfirmation";
import DeleteIcon from '@mui/icons-material/Delete';
import MyMaterialTable from "../../components/mtable/MyMaterialTable";
import {observer} from "mobx-react";

interface IProps {
}

interface IState {
    rules: CompanyRuleDto[],
    loading: boolean,
    error: boolean,
    showAddNew: boolean,
    modalInitData: CompanyRuleDto,
    index?: number;
}

class RulesList extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            rules: [],
            loading: true,
            error: false,
            showAddNew: false,
            modalInitData: {
                descContains: undefined,
                accCode: undefined,
                txType: undefined,
                creditorNameContains: undefined,
                debitorNameContains: undefined
            }
        };
    }

    async componentDidMount() {
        if (selectedCompanyStore.isSelected) {
            const selectedCompanyId = selectedCompanyStore.companyId;
            companyApi.fetchRules(selectedCompanyId)
                .then(response => {
                        this.setState({rules: response, loading: false})
                    }
                )
                .catch(() => this.setState({
                    loading: false,
                    error: true
                }));
            await companyAccountsStore.refresh()
        }
    }

    render() {
        const {rules, loading, error, showAddNew, modalInitData} = this.state;

        const dataToShow = rules.map((it, index) => {
            return {...it, index: index + 1};
        })

        return (
            <LoaderWithCompanySelected loading={loading} error={error}>
                <MyMaterialTable
                    title="Transaction matching rules"
                    columns={[
                        {title: '#', field: 'index', width: "2%", align: "center"},
                        {title: 'Type', field: 'txType', width: "4%", align: "center"},
                        {title: 'Rule', field: 'descContains', width: "15%", render: this.renderRuleDescription},
                        {hidden: true, searchable: true, field: 'descContains'},
                        {hidden: true, searchable: true, field: 'debitorNameContains'},
                        {hidden: true, searchable: true, field: 'creditorNameContains'},
                        {title: 'Acc code', field: 'accCode', width: '4%', align: "center"},
                    ]}
                    data={dataToShow}
                    options={{
                        search: true,
                        sorting: false,
                        paging: false,
                        draggable: false,
                        tableLayout: "auto",
                        rowStyle: (row: CompanyRuleDto) => row.txType === TxType.CRDT ? creditTableRowStyle : debitTableRowStyle,
                        actionsColumnIndex: 5
                    }}

                    actions={[
                        row => ({
                            icon: () => <Button variant="contained" color="primary" startIcon={<EditIcon/>}
                                                onClick={this.openAddNewDialog(row.index - 1)}>Edit</Button>,
                            onClick: () => {
                            }
                        }),
                        row => ({
                            icon: () => <ButtonWithConfirmation variant="contained" color="secondary"
                                                                onClick={this.deleteRule(row.index - 1)}
                                                                startIcon={<DeleteIcon/>}>
                                Delete
                            </ButtonWithConfirmation>,
                            onClick: () => {
                            }
                        }),
                    ]}
                />

                <RuleUpdateDialog show={showAddNew} initData={modalInitData}
                                  onSubmit={this.saveAndClose}
                                  onCancel={this.closeEditRuleDialog}
                />

                <Button variant="contained" color="primary" startIcon={<AddIcon/>}
                        onClick={this.openAddNewDialog(undefined)}>
                    Add new
                </Button>
            </LoaderWithCompanySelected>
        );
    }

    private renderRuleDescription = (row: CompanyRuleDto) => {
        const fields = [
            ["Description", row.descContains],
            ["Debitor", row.debitorNameContains],
            ["Creditor", row.creditorNameContains]
        ].filter(([, value]) => value)

        return <div>
            {
                fields
                    .map(([name, value]) =>
                        <><i><u>{name}</u></i> has '<b>{value}</b>'</>
                    )
                    .reduce((prev, curr) => <>{prev} AND {curr}</>)
            }
        </div>;
    }

    private openAddNewDialog = (index: number | undefined) => () => {
        let modalInitData: CompanyRuleDto;
        if (index == null) {
            modalInitData = {}
        } else {
            modalInitData = this.state.rules[index];
        }
        this.setState({
            showAddNew: true,
            index,
            modalInitData
        })
    }

    private closeEditRuleDialog = () => {
        this.setState({
            showAddNew: false
        })
    }

    private saveAndClose = async (changed: CompanyRuleDto) => {
        const oldRules = this.state.rules

        if (this.state.index == null) {
            oldRules.push(changed)
        } else {
            oldRules[this.state.index] = changed
        }
        await this.updateRules(oldRules);
    }

    private updateRules = async (rules: CompanyRuleDto[]) => {
        await companyApi.saveRules(selectedCompanyStore.companyId, rules)
        this.setState({
            rules: rules,
            showAddNew: false
        })
    }

    private deleteRule = (index: number) => async () => {
        const oldRules = this.state.rules
        const newRules = oldRules.filter((obj, curIndex) => curIndex !== index)
        await this.updateRules(newRules)
    }
}

export default observer(RulesList);